// group-url.service.ts
import { Injectable, inject } from '@angular/core';
// Constants
import { APP_CONSTANT, GROUPS_LIST, GROUP_URL } from '@constants';
// Utils
import { CommonService } from '@core/utils';
// Lodash
import { get } from 'lodash';
/**
 * Returns Base Url and Own stock link
 * 60: Systemtest
 * 1: Bildelsbasen
 * 2: Varaosahaku
 * 52: Autocirc
 * 48: Vefsalan
 * 34: markesdemo
 * 56: AutocircPartsFI
 */
@Injectable({ providedIn: 'root' })
export class GroupUrlService {
    private readonly commonService = inject(CommonService);

    /** Priority order is exactly the order in GROUPS_LIST */
    getBaseUrl(): string {
        const user = this.commonService.getFromLocalStorage(APP_CONSTANT.LOGGED_USER);
        const groups: number[] = get(user, 'company.group', []);

        // find first group that user belongs to, based on priority in GROUPS_LIST
        const matchedGroup = GROUPS_LIST.find(g => groups.includes(g.id));

        return matchedGroup?.url ?? GROUP_URL.BDB.url;
    }

    getOwnStockBaseUrl(): string {
        const user = this.commonService.getFromLocalStorage(APP_CONSTANT.LOGGED_USER);
        const groups: number[] = get(user, 'company.group', []);

        const matchedGroup = GROUPS_LIST.find(g => groups.includes(g.id));

        return matchedGroup?.ownStockUrl ?? GROUP_URL.BDB.ownStockUrl;
    }

    getCheckoutBaseUrl(): string {
        const user = this.commonService.getFromLocalStorage(APP_CONSTANT.LOGGED_USER);
        const groups: number[] = get(user, 'company.group', []);

        const matchedGroup = GROUPS_LIST.find(g => groups.includes(g.id));

        return matchedGroup?.checkoutUrl ?? GROUP_URL.BDB.checkoutUrl;
    }
}
